import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";

import { 
  Tool, 
} from "@dndModels";
import { ModelBase, PlayerObject } from "@models";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";

import LoadingBox from "@components/input/LoadingBox";
import StringBox from "@components/input/strings/StringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function ToolEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<Tool>(api.applyWorkingOn(new Tool()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    setFetched(true);
    if (id && id !== "") {
      setLoading(true);
      const onComplete = (res: PlayerObject[] | ModelBase[]) => {
        if (res.length === 1 && res[0] instanceof Tool) {
          setObj(res[0].clone());
          setChangeTime(common_util.get_time_number());
        }
        setLoading(false);
      };
      const onProgress = () => {};
      api.getObjectsWithCallbacks({ 
        data_type: "tool", filter: { _id: id },
        onComplete, onProgress 
      });
    }
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("tool", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/tool");
  //     });
  //   }
  // }

  const height = window.innerHeight - 105;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else { 
    return (
      <ModelBaseInput 
        obj={obj}
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: ModelBase) => {
          if (changed instanceof Tool) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }
        }}>
        <StringBox 
          value={obj.type} 
          name="Type"
          disabled={disabled}
          onBlur={(changed: string) => {
            const new_obj = obj;
            new_obj.type = changed;
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }}
        />
      </ModelBaseInput>
    ); 
  }
}
